define([
    "uiComponent",
    'bootstrap/collapse' // collapses are initialized via data attributes
], function (Component) {
    "use strict";

    return Component.extend({

        /** @inheritdoc */
        initialize: function (config, element) {
            this._super(config, element);

            if (!element) {
               return;
            }

            var showingClass = 'showing';
            var hidingClass = 'hiding';

            element.addEventListener('show.bs.collapse', function () {
                element.classList.add(showingClass);
            });

            element.addEventListener('shown.bs.collapse', function () {
                element.classList.remove(showingClass);
            });

            element.addEventListener('hide.bs.collapse', function () {
                element.classList.add(hidingClass);
            });

            element.addEventListener('hidden.bs.collapse', function () {
                element.classList.remove(hidingClass);
            });

        }
    });
});
